// Voice-note / voice-call turns are persisted with their transcript wrapped in
// <voice> tags (the harness's transcription convention — also the shape of
// WhatsApp-captured voice notes already in prod). The display rule everywhere:
// strip the tags and render the bare transcript, slightly quieter than normal
// body text, below the audio player when the row carries an audio attachment.
export const VOICE_WRAPPER = /^<voice>([\s\S]*)<\/voice>$/;

// The bare transcript of a `<voice>…</voice>` message, or null when the text
// isn't a voice turn. Only an exact whole-message match counts — a <voice> tag
// quoted mid-sentence is ordinary text.
export function voiceTranscript(content: string | undefined | null): string | null {
  if (!content) return null;
  const match = content.trim().match(VOICE_WRAPPER);
  return match ? match[1].trim() : null;
}

export function isAudioAttachment(mimeType: string | undefined | null): boolean {
  return !!mimeType && mimeType.toLowerCase().startsWith('audio/');
}

// Defensive render-side strip of the `<voice>` transcript wrapper for an assistant
// body. A whole-message voice turn is handled by `voiceTranscript` (rendered as a
// dimmed transcript); this removes any residual `<voice>`/`</voice>` tags the model
// echoes back mid-prose, keeping the inner words. Mirrors the native
// `ChatText.sanitizeAssistantMessage` strip.
export function stripVoiceTags(text: string): string {
  return text.replace(/<\/?voice>/gi, '');
}
